// Client-side fire-and-forget beacon for funnel tracking.
//
// Calls POST /api/v1/funnel/beacon with keepalive so the request
// survives a navigation. Server enforces dedup per session per
// window, so calling this on every relevant render is safe.

export type BeaconKind = "site_visit" | "price_quote";

export function fireBeacon(
  kind: BeaconKind,
  extra: { countryCode?: string; cryptoType?: string; usdValue?: number } = {},
): void {
  if (typeof window === "undefined") return;
  try {
    fetch("/api/v1/funnel/beacon", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ kind, ...extra }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Swallow — analytics that errors itself is just noise.
  }
}
